import { render, staticRenderFns } from "./ExtratoHonorariosEfSefa.vue?vue&type=template&id=229f317f&scoped=true&"
import script from "./ExtratoHonorariosEfSefa.vue?vue&type=script&lang=js&"
export * from "./ExtratoHonorariosEfSefa.vue?vue&type=script&lang=js&"
import style0 from "./ExtratoHonorariosEfSefa.vue?vue&type=style&index=0&id=229f317f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "229f317f",
  null
  
)

export default component.exports